import { render } from "./myLuckydrawOne.vue?vue&type=template&id=4b2efcf2&scoped=true"
import script from "./myLuckydrawOne.vue?vue&type=script&lang=js"
export * from "./myLuckydrawOne.vue?vue&type=script&lang=js"

import "./myLuckydrawOne.vue?vue&type=style&index=0&id=4b2efcf2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2efcf2"]])

export default __exports__